import { isEmptyValue, normalizeNumberInput, percentageFormatter } from '@utils/format-functions';

export function getPercentageNumericValue(value: string | undefined): number | string {
    if (!value || value === '') return '';
    try {
        const numericValue = Number.parseFloat(value.toString().replace('%', ''));
        if (Number.isNaN(numericValue)) return '';
        return numericValue / 100;
    } catch {
        return '';
    }
}

export function formatProbabilityRaw(
    value: number | string | null | undefined,
    formatter: (n: number) => string = (n) => percentageFormatter(n) ?? ''
): string {
    if (isEmptyValue(value)) {
        return '';
    }

    const numeric = normalizeNumberInput(value);

    if (numeric === null) {
        return '';
    }

    if (numeric === 0) {
        return '0.00%';
    }

    return formatter(numeric);
}
